import AuthService from '@/services/auth-service'
import TokenValidator from '@/services/token-validator'
import { AuthObject, User } from '@/types'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const state = ref({ status: { loggedIn: false }, user: {} as User })

  const isLoggedIn = computed((): boolean => {
    return state.value.status.loggedIn
  })

  const username = computed((): string => {
    return state.value.user.username
  })

  const isUserAdmin = computed((): boolean => {
    if (isLoggedIn.value) {
      return (
        state.value.user &&
        state.value.user?.roles?.find((role: string) => role === 'ROLE_ADMIN') !== null
      )
    }
    return false
  })

  const canCreateOrUpdate = computed(() => {
    return isLoggedIn.value && isUserAdmin.value
  })

  const userFromStorage: string | null = localStorage.getItem('user')
  if (userFromStorage) {
    const user = JSON.parse(userFromStorage)
    if (user) {
      try {
        TokenValidator.isTokenActive(user.accessToken)
        state.value = { status: { loggedIn: true }, user }
      } catch (error) {
        // do something with error
      }
    }
  }

  async function authUser(userToAuth: AuthObject) {
    return AuthService.login(userToAuth).then(
      (user: User) => {
        state.value.status.loggedIn = true
        state.value.user = user
        return Promise.resolve(user)
      },
      (error: any) => {
        return Promise.reject(error)
      }
    )
  }

  async function logOutUser() {
    AuthService.logout()
    state.value.status.loggedIn = false
  }

  return { isLoggedIn, isUserAdmin, canCreateOrUpdate, username, authUser, logOutUser }
})
